import { render } from "./RecursiveComment.vue?vue&type=template&id=375dc367&scoped=true"
import script from "./RecursiveComment.vue?vue&type=script&lang=js"
export * from "./RecursiveComment.vue?vue&type=script&lang=js"

import "./RecursiveComment.vue?vue&type=style&index=0&id=375dc367&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375dc367"]])

export default __exports__